// useAuth.js
import { useState, useEffect } from 'react';
import { getToken } from '../utils/auth'; // Ensure getToken function is correctly implemented

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('user', isAuthenticated);
    document.body.classList.toggle('guest', !isAuthenticated);
  }, [isAuthenticated])
  
  useEffect(() => {
    checkAuthenticated(); // Check authentication status on component mount
  }, []);

  const checkAuthenticated = () => {
    const token = getToken();
    if (token) {
      setIsAuthenticated(true);

    } else {
      setIsAuthenticated(false);
    }
  };

  const login = (data) => {
    localStorage.setItem('jwtToken', data.jwtToken);
    localStorage.setItem('userId', data.userName);
    localStorage.setItem('user', JSON.stringify(data));
    setIsAuthenticated(true);
  };

  const logout = (options = {}) => {
    const { setSessionExpiredFlag = false } = options;
    
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('user');
    
    // Set a flag to show session expired message if requested
    if (setSessionExpiredFlag) {
      localStorage.setItem('sessionExpired', 'true');
    }
    
    setIsAuthenticated(false);
  };

  return {
    isAuthenticated,
    checkAuthenticated, // Ensure checkAuthenticated is returned from the hook
    login,
    logout,
  };
};

export default useAuth;
